import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sixmonthcorporatecabrentalsinmumbai() {



  const cardData =
  {
    keyword: 'Six-Month Corporate Cab Rentals in Mumbai',
    heading: 'Aaryan Travels: Six-Month Corporate Cab Rentals in Mumbai',
    headingDescription: 'Aaryan Travels offers Six-Month Corporate Cab Rentals in Mumbai for businesses and executives who require stable and long-term transportation without the hassle of daily bookings. Whether it’s for project-based employee commute, executive allocation, or dedicated airport transfers from Chhatrapati Shivaji Maharaj International Airport, our fleet of sedans, SUVs, and premium vehicles is available on flexible six-month rental contracts. With uniformed chauffeurs, GPS-enabled cars, punctual reporting, and transparent billing, we provide professional corporate travel solutions across Andheri, BKC, Navi Mumbai, Thane, and South Mumbai. Aaryan Travels ensures convenience, cost-efficiency, and reliability through structured six-month cab rental plans tailored for corporate needs.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924 overlooking the Arabian Sea, the Gateway of India is Mumbai’s most iconic landmark. Once a ceremonial entrance during British rule, it now serves as a major tourist gathering spot. Visitors enjoy ferry rides to Elephanta Caves and the bustling atmosphere around the monument. Illuminated at night, it offers a majestic sight. The Gateway of India is Mumbai’s grand symbol of heritage and pride."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace due to its glowing curve of lights at night, is a 3.6 km-long promenade along the Arabian Sea. Locals come here for evening walks, street snacks, and ocean views. The cool sea breeze and stunning sunsets make it a favorite relaxation spot. Marine Drive is Mumbai’s timeless coastal escape."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST is a UNESCO World Heritage Site and one of India’s most beautiful railway stations. Built in 1887 in Victorian Gothic style, it features stained-glass windows, domes, and intricate carvings. Despite being a major transit hub, it looks like a royal palace. Illuminated beautifully at night, it becomes a stunning visual landmark. CST is Mumbai’s perfect mix of history and hustle."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, known for its lively atmosphere and street food stalls selling pav bhaji, bhel puri, and gola ice. Families enjoy camel rides while children play along the shoreline. Many Bollywood celebrities reside nearby, adding glamour to the area. Juhu Beach is Mumbai’s cheerful seaside hotspot."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb situated on a small islet connected by a narrow pathway. During high tide, it appears to float in the sea. People of all faiths visit to seek blessings and listen to soulful qawwali music. Its white marble structure offers peace and beauty. Haji Ali is Mumbai’s sacred haven of spirituality."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these ancient rock-cut caves date back to the 5th century and are dedicated to Lord Shiva. The Trimurti sculpture depicting three forms of Shiva is the main attraction. Ferries from Gateway of India take visitors to the island. Surrounded by history and nature, the site offers a serene escape. Elephanta Caves are Mumbai’s heritage carved in stone."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered temples dedicated to Lord Ganesha. Devotees, including celebrities and politicians, seek blessings here regularly. The gold-plated dome and beautifully adorned idol add to its divine charm. Special prayers on Tuesdays draw massive crowds. Siddhivinayak is Mumbai’s spiritual powerhouse."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed bridge connecting South Mumbai to its western suburbs. Driving across offers stunning views of the skyline and sea. At night, the illuminated cables create a futuristic spectacle. It has reduced travel time while adding architectural beauty. The Sea Link is Mumbai’s symbol of modern progress."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street market famous for fashion accessories, antiques, and local handicrafts. Bargain hunters explore endless stalls while enjoying snacks from roadside vendors. Iconic cafes like Leopold and Mondegar add vintage charm. It’s a must-visit for tourists. Colaba Causeway is Mumbai’s vibrant shopping trail."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests offering safaris, trekking trails, and boating. The ancient Kanheri Caves inside the park add a historic touch. Visitors often spot deer, monkeys, and birds along the paths. It provides fresh air and greenery just minutes from city chaos. SGNP is Mumbai’s wild escape into nature."
  }
],


"services": [
  {
    "name": "Six-Month Corporate Cab Rentals in Mumbai",
    "description": "Six-Month Corporate Cab Rentals in Mumbai provide businesses with reliable, flexible, and cost-effective transportation solutions for half-year durations. Designed to meet the evolving needs of corporate clients, this service offers access to a well-maintained fleet of vehicles driven by professional chauffeurs who prioritize punctuality, safety, and comfort. With customizable plans, businesses can ensure seamless employee and client transport, minimize administrative hassle, and enjoy transparent pricing throughout the six-month term."
  },
  {
    "name": "Mumbai 6 Month Corporate Cab Hire",
    "description": "Mumbai 6 Month Corporate Cab Hire offers dedicated corporate vehicle rentals for a six-month period, ideal for businesses with ongoing transportation needs. The service guarantees well-maintained cars, experienced drivers, and prompt pickups, ensuring uninterrupted and professional travel support."
  },
  {
    "name": "Half Year Corporate Cab Mumbai",
    "description": "Half Year Corporate Cab Mumbai specializes in providing corporate clients with dependable and convenient transportation solutions spanning six months. This service helps companies manage employee commutes and client transfers efficiently with consistent quality and safety standards."
  },
  {
    "name": "Business Cab for 6 Months Mumbai",
    "description": "Business Cab for 6 Months Mumbai is tailored for companies seeking reliable transportation over half a year. Featuring comfortable vehicles and professional chauffeurs, the service supports regular business travel, meetings, and events with ease and professionalism."
  },
  {
    "name": "Office Transport Mumbai 6 Months",
    "description": "Office Transport Mumbai 6 Months offers consistent and secure transportation for employees on a half-year basis. Emphasizing punctuality and comfort, this service helps businesses maintain workforce productivity and streamline daily commutes."
  },
  {
    "name": "Staff Cab Mumbai 6 Months",
    "description": "Staff Cab Mumbai 6 Months provides affordable, reliable, and long-term transportation solutions for staff members. Companies can count on professional drivers and well-maintained vehicles to ensure safe and comfortable journeys throughout the six-month period."
  },
  {
    "name": "Chauffeur Corporate Cab Mumbai",
    "description": "Chauffeur Corporate Cab Mumbai delivers premium chauffeur-driven vehicles tailored for corporate clients. With professional drivers skilled in corporate etiquette, this service guarantees discretion, comfort, and a seamless travel experience for executives and VIPs."
  },
  {
    "name": "Corporate Vehicle Rental Mumbai",
    "description": "Corporate Vehicle Rental Mumbai features a versatile fleet of vehicles available for corporate rentals, including long-term options. The service caters to diverse business needs, offering reliable transportation with trained drivers and flexible rental durations."
  },
  {
    "name": "Executive Cab Mumbai 6 Months",
    "description": "Executive Cab Mumbai 6 Months is designed for senior executives requiring luxury and punctual transport over a six-month term. The service combines high-end vehicles with professional chauffeurs to provide a superior travel experience."
  },
  {
    "name": "Affordable 6 Month Corporate Cab Mumbai",
    "description": "Affordable 6 Month Corporate Cab Mumbai delivers cost-effective corporate transportation without compromising on service quality. Transparent pricing and flexible plans make this an ideal choice for businesses aiming to optimize their travel budgets."
  },
  {
    "name": "Corporate Car Leasing Mumbai",
    "description": "Corporate Car Leasing Mumbai offers leasing solutions for companies needing dedicated vehicles with comprehensive maintenance and driver services. These leasing plans provide a hassle-free option for medium-term corporate transportation."
  },
  {
    "name": "Online Corporate Cab Mumbai",
    "description": "Online Corporate Cab Mumbai streamlines the booking and management of six-month corporate cab rentals through a digital platform. Features include instant confirmations, real-time ride tracking, and convenient billing options to simplify corporate travel management."
  },
  {
    "name": "6 Month Business Cab Mumbai",
    "description": "6 Month Business Cab Mumbai supports organizations with reliable and consistent business transportation over half a year. The service ensures availability of clean vehicles and professional drivers to meet daily commuting and event requirements."
  },
  {
    "name": "Long Term Corporate Cab Mumbai",
    "description": "Long Term Corporate Cab Mumbai provides extended rental options for companies requiring dependable transportation for employees and clients. This service emphasizes flexibility, cost savings, and consistent high-quality service throughout the rental period."
  },
  {
    "name": "Premium Corporate Cab Mumbai",
    "description": "Premium Corporate Cab Mumbai offers top-tier corporate transportation services featuring luxury vehicles and professional chauffeurs. Ideal for VIP clients and executives, this service delivers a superior travel experience with utmost professionalism and comfort."
  }
],
"tableData": [
  ["Six-Month Corporate Cab Rentals in Mumbai", "Mumbai 6 Month Corporate Cab Hire"],
  ["Half Year Corporate Cab Mumbai", "Business Cab for 6 Months Mumbai"],
  ["Office Transport Mumbai 6 Months", "Staff Cab Mumbai 6 Months"],
  ["Chauffeur Corporate Cab Mumbai", "Corporate Vehicle Rental Mumbai"],
  ["Executive Cab Mumbai 6 Months", "Affordable 6 Month Corporate Cab Mumbai"],
  ["Corporate Car Leasing Mumbai", "Online Corporate Cab Mumbai"],
  ["6 Month Business Cab Mumbai", "Long Term Corporate Cab Mumbai"],
  ["Premium Corporate Cab Mumbai", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Six-Month Corporate Cab Rentals in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers dependable six-month corporate cab rentals in Mumbai for smooth and consistent business commuting."
  },
  {
    "WhyChooseheading": "Professional and Punctual Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure timely pickups and drop-offs to keep your corporate schedule on track."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for comfort and safety throughout the rental period."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai Routes",
    "WhyChoosedescription": "Our drivers have expert knowledge of Mumbai’s roads to provide efficient and hassle-free rides."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy fixed pricing inclusive of fuel, tolls, and driver allowances for stress-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Corporate Clients",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings and inquiries."
  },
  {
    "WhyChooseheading": "Customizable Plans to Fit Your Business Needs",
    "WhyChoosedescription": "Choose from various plans and vehicle types tailored to your corporate travel requirements."
  },
  {
    "WhyChooseheading": "Priority Service with Dedicated Fleet",
    "WhyChoosedescription": "Benefit from priority bookings and a dedicated fleet ensuring uninterrupted corporate travel."
  }
]















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer six-month corporate cab rentals in Mumbai?',
    answer: 'Yes, Aaryan Travels provides flexible and affordable six-month corporate cab rental plans in Mumbai tailored to meet your business travel needs.',
  },
  {
    question: 'How can I book six-month corporate cab rentals in Mumbai with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our dedicated 24x7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for six-month corporate rentals in Mumbai?',
    answer: 'Aaryan Travels offers a range of vehicles including sedans, SUVs, and premium cars suited for corporate travel.',
  },
  {
    question: 'Are drivers experienced and trained for six-month corporate cab services in Mumbai?',
    answer: 'Absolutely. Our drivers are licensed, professional, and trained to provide safe and timely service throughout your rental period.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for six-month corporate cab rentals?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Mumbai and surrounding business districts.',
  },
  {
    question: 'Is the six-month corporate cab rental service available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock service to accommodate your business schedules.',
  },
  {
    question: 'Are safety and hygiene protocols followed during six-month rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are available for six-month corporate cab rentals in Mumbai?',
    answer: 'We accept payments via corporate accounts, digital wallets, UPI, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available throughout the six-month rental period?',
    answer: 'Yes, our 24x7 customer support team is always available to assist you during your rental duration.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehta',
    feedback: 'Aaryan Travels’ six-month corporate cab rental plan in Mumbai was efficient and cost-effective for our company’s needs.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Shah',
    feedback: 'Professional drivers and excellent service throughout the six-month rental. Highly recommend Aaryan Travels in Mumbai!',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const sixMonthCorporateCabMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Six-Month Corporate Cab Rentals in Mumbai",
  "description": "Aaryan Travels offers affordable six-month corporate cab rentals in Mumbai including chauffeur-driven executive and staff transport services with flexible leasing options.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "Six-Month Corporate Cab Rental Service",
  "keywords": "Six-Month Corporate Cab Rentals in Mumbai, Mumbai 6 Month Corporate Cab Hire, Half Year Corporate Cab Mumbai, Business Cab for 6 Months Mumbai, Office Transport Mumbai 6 Months, Staff Cab Mumbai 6 Months, Chauffeur Corporate Cab Mumbai, Corporate Vehicle Rental Mumbai, Executive Cab Mumbai 6 Months, Affordable 6 Month Corporate Cab Mumbai, Corporate Car Leasing Mumbai, Online Corporate Cab Mumbai, 6 Month Business Cab Mumbai, Long Term Corporate Cab Mumbai, Premium Corporate Cab Mumbai"
};




  return (
    <div>

<Helmet>
  <title>Six-Month Corporate Cab Rentals in Mumbai | Affordable Executive Transport | Aaryan Travels</title>
  <meta
    name="description"
    content="Book six-month corporate cab rentals in Mumbai with chauffeur-driven executive and staff transport services by Aaryan Travels. Flexible plans and affordable rates."
  />
  <meta
    name="keywords"
    content="Six-Month Corporate Cab Rentals in Mumbai, Mumbai 6 Month Corporate Cab Hire, Half Year Corporate Cab Mumbai, Business Cab for 6 Months Mumbai, Office Transport Mumbai 6 Months, Staff Cab Mumbai 6 Months, Chauffeur Corporate Cab Mumbai, Corporate Vehicle Rental Mumbai, Executive Cab Mumbai 6 Months, Affordable 6 Month Corporate Cab Mumbai, Corporate Car Leasing Mumbai, Online Corporate Cab Mumbai, 6 Month Business Cab Mumbai, Long Term Corporate Cab Mumbai, Premium Corporate Cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(sixMonthCorporateCabMumbaiSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/67.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sixmonthcorporatecabrentalsinmumbai;